
import { defineComponent, computed, ref } from 'vue'
import { WhitelistedIP } from '@/modules/whitelisted-ips/types'
import { useRoute, useRouter } from 'vue-router'
import { useWhitelistedIPsModule } from '@/modules/whitelisted-ips'
import { WhitelistedIpsRouteNames } from '@/router/routes-names'
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo, storeFormModel } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'view-whitelisted-ips',
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    setup (props) {
        const { getWhitelistedIPs, whitelistedIPs } = useWhitelistedIPsModule()
        const router = useRouter()
        const route = useRoute()
        const { pagination } = usePaginationHelper('creationTime')

        const whitelistedIPsColumns = ([
            { name: 'ip', label: 'IP', field: 'ip', sortable: true, align: 'left' },
            { name: 'description', label: 'Description', field: 'description', sortable: true, align: 'left' },
            { name: 'creationTime', label: 'Creation time', field: 'creationTime', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.WHITELISTED_IPS_LIST_FILTERS)
        }

        const filter = ref<string>(restoredFilter.value ?? '')

        const filteredWhiteListedIps = computed(() => {
            storeFormModel({ value: filter.value }, FormModelCacheTag.WHITELISTED_IPS_LIST_FILTERS)
            if (filter.value === '') {
                return whitelistedIPs.value
            }

            const regexp = new RegExp(filter.value, 'i')
            return whitelistedIPs.value.filter(whitelistedIp => regexp.test(`${whitelistedIp.description} ${whitelistedIp.ip}`))
        })

        function onShowWhitelistedIP (evt: PointerEvent | null, props: WhitelistedIP) {
            router.push({ name: WhitelistedIpsRouteNames.SHOW, params: { ip: props.ip, description: props.description, creationTime: props.creationTime }, query: { page: route.query.page } })
        }

        getWhitelistedIPs()

        return {
            filteredWhiteListedIps,
            whitelistedIPsColumns,
            onShowWhitelistedIP,
            pagination,
            filter
        }
    }
})
